var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFbs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333008,
    width: 36,
    height: 36,
    rx: 12,
    fill: "#1877F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8549 28.1851V21.3752H22.1254L22.5576 18.5579H19.8549V16.7294C19.8549 15.9584 20.233 15.2086 21.4428 15.2086H22.6722V12.812C22.6722 12.812 21.5574 12.6205 20.4917 12.6205C18.2638 12.6205 16.8101 13.9694 16.8101 16.4118V18.5579H14.335V21.3752H16.8101V28.1851C12.1529 27.4534 8.59082 23.4215 8.59082 18.558C8.59072 13.1755 12.9501 8.81445 18.3325 8.81445C23.7149 8.81445 28.0759 13.1754 28.0759 18.5579C28.0759 23.4214 24.5138 27.4534 19.8549 28.1851Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbs);
export default __webpack_public_path__ + "static/media/fbs.32472553be770ea151c97f718f0bb539.svg";
export { ForwardRef as ReactComponent };